import { render, staticRenderFns } from "./SettlementName.vue?vue&type=template&id=7a5a3dc0&scoped=true&"
import script from "./SettlementName.vue?vue&type=script&lang=js&"
export * from "./SettlementName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5a3dc0",
  null
  
)

export default component.exports